module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content.length > _vm.minLength) ? _c('div', {
    staticClass: "text-overflow"
  }, [_c('el-popover', {
    attrs: {
      "placement": "top-start",
      "trigger": "hover",
      "width": _vm.width
    }
  }, [(_vm.column.magnifying) ? _c('span', [_c('img', {
    attrs: {
      "src": _vm.data,
      "width": _vm.column.magnifying.width,
      "height": _vm.column.magnifying.height
    }
  })]) : _c('span', {
    staticClass: "text-break"
  }, [_vm._v("\n      " + _vm._s(_vm.content) + "\n    ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._t("default", null, {
    content: _vm.content
  })], 2)])], 1) : _c('div', {
    staticClass: "text-overflow"
  }, [_vm._t("default", null, {
    content: _vm.content
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3896dde0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoRender/index.vue
// module id = 1736
// module chunks = 1